<template>
  <div class="active">
    <div class="activetitle">GR 试驾交流活动 — 广州站</div>
    <div class="mb-100">
      <van-cell-group>
        <div class="box">
          <span class="titlenum">01</span>
          <span class="titlename">您的姓名</span>
        </div>
        <van-field v-model="params.name" placeholder="填写姓名" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">02</span>
          <span class="titlename">您的手机号</span>
        </div>
        <van-field v-model="params.mobile" placeholder="填写手机号" maxlength='11' type='tel' />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">03</span>
          <span class="titlename">参与试驾人数</span>
        </div>
        <van-field v-model="params.man_num" type='number' placeholder="填写数字"  />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">04</span>
          <span class="titlename">陪同人员人数（无试乘试驾需求）</span>
        </div>
        <van-field v-model="params.child_num" type='number' placeholder="填写数字"  />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">05</span>
          <span class="titlename">您预计参与时间</span>
        </div>
        <van-radio-group v-model="params.time">
          <van-radio name="28日上午" checked-color="#605C6B">28日上午</van-radio>
          <van-radio name="29日上午" checked-color="#605C6B">29日上午</van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group v-if="params.is_drive==1">
        <div class="box">
          <span class="titlenum">06</span>
          <span class="titlename">试驾车型</span>
        </div>
        <van-field readonly v-model="params.car_model_name" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">07</span>
          <span class="titlename">您是否有意愿在此次试驾会后订车？</span>
        </div>
        <van-radio-group v-model="params.other">
          <van-radio name="会订车" checked-color="#605C6B">是</van-radio>
          <van-radio name="不会订车" checked-color="#605C6B">否</van-radio>
        </van-radio-group>
      </van-cell-group>
    </div>
    <div class="btn-box">
      <van-button color="#605C6B" size="large" @click="saveInfo">确认提交</van-button>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
      title=""
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="onCancel"
      @change="onChange"
      />
    </van-popup>
  </div>

</template>
<script>
  import active from '../../../api/lexus/active';
  import list from '../../../api/member/mycars';
  import common from '../../../api/common';
  import {Field,Button,RadioGroup,Radio,Cell, CellGroup,Picker,Popup } from 'vant';
  export default {
    data () {
      return {
        params:{
          hid:14,
          name:'',
          man_num:'',
          time:'',
          child_num:'',
          is_drive:1,
          car_model_id:1567,
          car_model_name:'TOYOTA SUPRA',
          other: ''
        },
        showPicker:false,
        columns: [],
        again:0
      }
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      
      
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      // this.getCars()
      if(Lockr.get('token')){
        this.$store.dispatch('param/setToken', Lockr.get('token'))
      }else{
        this.getAuthorization.getAuthorization();
      }

      
      // if(this.$route.query.token){
      //   this.id = this.$route.query.id
      //   this.source = this.$route.query.source
      //   this.token = this.$route.query.token
      //   this.user_id = this.$route.query.userid
      //   this.$store.dispatch('param/setToken', this.$route.query.token)
      //   this.getActivity(this.$route.query.userid)
      // }else if(this.$route.params.token){
      //   this.id = this.$route.query.id
      //   this.source = this.$route.params.source
      //   this.token = this.$route.params.token
      //   this.$store.dispatch('param/setToken', this.token)
      //   this.user_id = this.$route.params.user_id
      //   this.again=this.$route.params.again
      //   this.getActivity(this.$route.params.user_id)
      // }
    },
    methods: {
      getCars(){
        var params={
          brand_id:110,
          region:1567
        }
        list.getCars(params).then(res => {
          if(res.data.state == 1) {
            var lists=res.data.data
            var columns =[]
            for (let i in lists) {
              var params={
                text:lists[i].title,
                id:lists[i].id
              }
              columns.push(params); 
            }
            this.columns=columns

          }
        })
      },
      getActivity(id){
        var params={
          user_id:parseInt([id]),
        }
        common.getActivity(params,14).then(res => {
          if(res.data.state==1){
            this.activeinfo=res.data.data
            if(res.data.data.is_enroll==1&&this.again==0){
              // this.$router.push({name:'LexusActiveok',params:{source:this.source,token:this.token,user_id:this.user_id}});
              wx.miniProgram.reLaunch({url: '/pages/webpage/webpage?scene=https://m.motortime.com/active'})
            }
            var params={
              event_code: '活动邀请',
              event_id: res.data.data.id,
              title: res.data.data.title,
              value: '',
              path: '/Motortime/Active/Active.vue',
              user_id: this.user_id ? this.user_id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){

              }
            })
          }
        })
      },
      
      saveInfo(){
        if(this.params.name==''){
          this.$toast('请填写您的姓名');
          return false
        }else if(this.params.mobile==''){
          this.$toast('请填写您的手机号');
          return false
        }else if(!(/^1[3456789]\d{9}$/.test(this.params.mobile))){
          this.$toast('请填写正确的手机号');
          return false
        }else if(this.params.man_num==''){
          this.$toast('请填写参与试驾人数');
          return false
        }else if(this.params.child_num==''){
          this.$toast('请填写陪同人员人数');
          return false
        }else if(this.params.time==''){
          this.$toast('请选择参与时间');
          return false
        }
        if(this.params.other==''){
          this.$toast('请选择是否有意愿在此次试驾会后订车');
          return false
        }

        common.activeApplyAll(this.params).then(res => {
          if(res.data.state==1){
             // this.$router.push({name:'LexusActiveok',params:{source:this.source,token:this.token,user_id:this.user_id}});
             // wx.miniProgram.reLaunch({url: '/pages/webview/webview?scene=https://m.motortime.com/lexus/active/activeok'})
             var params={
              hid:14,
              name:'',
              man_num:'',
              time:'',
              child_num:'',
              is_drive:1,
              car_model_id:1567,
              car_model_name:'TOYOTA SUPRA',
              other: ''
            }
            this.params=params

            this.$dialog.alert({
              title: '温馨提示',
              message: '您已报名，具体细节我们将通过“GR FANS 服务区“微信号与您联系，感谢您的参与！'
            })
          } else {
            this.$toast('报名失败');
            return false
          }
        })
      },
      onConfirm(value, index) {
        this.showPicker=false
        this.params.car_model_name=value.text
        this.params.car_model_id=value.id
        // Toast(`当前值：${value}, 当前索引：${index}`);
      },
      onChange(picker, value, index) {
        // Toast(`当前值：${value}, 当前索引：${index}`);
      },
      onCancel() {
        // Toast('取消');
      },
    },
    components: {
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Field.name]:Field,
      [Button.name]:Button,
      [Cell.name]: Cell,
      [CellGroup.name]:CellGroup,
      [Picker.name]:Picker,
      [Popup.name]:Popup
    }
  }
</script>
<style lang="scss">
.active{
  .activetitle{
    font-size: 16px;
    text-align: center;
    margin: 30px 0;
    font-weight: bold;
  }
  .van-cell-group{
    padding: 5px 0;
  }
  .box{
    margin-left: 15px;
    .titlenum{
      font-size: 20px;
      font-weight: bold;
      color: #3A3A3A;
    }
    .titlename{
      font-size: 14px;
      color: #3A3A3A;
      margin-left: 5px;
    }
  }
  .van-radio-group{
    display: flex;
    padding: 10px 15px;
  }
  .van-radio{
    margin-right: 40px;
    .van-radio__label{
      font-size: 14px;
    }
  }
  .btn-box{
    width: 100%;
    bottom: 20px;
    position: fixed;
    text-align: center;
    -webkit-user-select: none;/*禁用手机浏览器的用户选择功能 */
    -moz-user-select: none;
    -webkit-touch-callout: none;
    -ms-user-select:none; /*IE10*/
    user-select:none;
    .van-button--large{
      width: 90%;
    }
  }
  .mb-100{
    margin-bottom: 100px;
  }
  .mb-240{
    margin-bottom: 240px;
  }

}
</style>
